import React from 'react'
import { observer } from 'mobx-react-lite'
import CampaignInfluencerComments from './CampaignInfluencerComments'
import CampaignInfluencerThread from '../../../../../Shared/CampaignInfluencerSidebar/CampaignInfluencerThread'


export default observer(function ClientThread({ auth }) {
  return (
    <CampaignInfluencerThread
      auth={auth}
      CommentsComponent={CampaignInfluencerComments}
      isClientThread
    />
  )
})
